<template>
  <div id="app">
    
    <router-view />
    <footer-com></footer-com>
    <!-- <new-gift/> -->
  </div>
</template>
<script>
  import orderApi from '@/axios/order';
  export default {
    data () {
      return {
       
      }
    },
    created () {
      //添加优惠券逻辑 
      // this.getCon();
    },
    methods: {
   
    
    }
  }
</script>
<style lang="scss" >
// html,body{
//    width:100%;
//    height:100%;
// }
// #app{
//     width:100%;
//     height:100%;
// }

.couponsTitle{
    text-align: center;
    color:#4A4A4A;
    font-size: 48px;
    margin-bottom: 40px;
}
.applyBtn_content{
    display: flex;
    justify-content: center;
}
.applyBtn{
    width: 240px!important;
    height: 72px!important;
    border-radius: 36px!important;
    margin-top: 20px;
}
.couponsContent{
    background: rgba(243,251,251,1);
    padding:40px;
    .couponsList{
        width: 610px;
        height: 180px;
        background: url('/images/order/couponsBg.png') no-repeat;
        background-size:100%; 
        box-shadow:0px 1px 10px 0px rgba(0,0,0,0.1);
        display: flex;
        margin-bottom: 20px;

        .text_content{
            margin-left:250px;
            margin-top: 25px;
            font-size:26px; 
            .title{
                line-height: 70px;
                span{
                    font-size:55px; 
                }
            }
            .dero{
                line-height: 40px;
                color:#666666;
            }
        }
    }
}
</style>
